import { ReactComponent as Warning } from './assets/ic_error_warning.svg';
import { ReactComponent as NoAddress } from './assets/ic_no_address.svg';
import { ReactComponent as NoOrders } from './assets/no_orders.svg';
import { ReactComponent as OrderCanceled } from './assets/ic_order_canceled.svg';
import { ReactComponent as NoPickup } from './assets/ic_nopickup.svg';
import { ReactComponent as NoDelivery } from './assets/ic_nodelivery.svg';
import { ReactComponent as NotInArea } from './assets/ic_welcomeError_notInArea.svg';
import { ReactComponent as NotCreditCard } from './assets/ic_no_credit_card.svg';
import { ReactComponent as NoCompanies } from './assets/ic_nocompanies.svg';

// TODO: replace noCoupons with the no coupons asset

export const ERROR_IMAGES = {
  warning: Warning,
  noAddress: NoAddress,
  noOrders: NoOrders,
  orderCanceled: OrderCanceled,
  noPickup: NoPickup,
  noDelivery: NoDelivery,
  notInArea: NotInArea,
  noCoupons: NoAddress,
  noCreditCards: NotCreditCard,
  noCompanies: NoCompanies
};
